import React from 'react';
import SEOHead from '../components/SEOHead';

const TermsAndConditions = () => {
  const title = 'Terms and Conditions | TradeRadar';
  const description =
    'Terms and Conditions for using the TradeRadar website, including acceptable use, intellectual property, disclaimers, and limitations of liability.';

  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <SEOHead
        title={title}
        description={description}
        path="/terms-and-conditions"
        keywords="TradeRadar terms, website terms and conditions"
      />

      <header className="mb-8">
        <h1 className="text-3xl font-bold text-slate-900 dark:text-on-surface mb-3">
          Terms and Conditions
        </h1>
        <p className="text-sm text-slate-600 dark:text-on-surface-variant">
          Effective date: March 2026
        </p>
      </header>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-slate-900 dark:text-on-surface mb-2">
          1. Acceptance of Terms
        </h2>
        <p className="text-sm text-slate-700 dark:text-on-surface-variant leading-relaxed">
          By accessing or using the TradeRadar website, you agree to be bound by these Terms and
          Conditions, as well as any additional policies referenced on this page. If you do not
          agree to these terms, you should not use the site.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-slate-900 dark:text-on-surface mb-2">
          2. Use of the Website
        </h2>
        <ul className="text-sm text-slate-700 dark:text-on-surface-variant space-y-2 list-disc list-inside">
          <li>
            You may use the site for personal or professional information purposes, subject to these
            terms.
          </li>
          <li>
            You agree not to misuse the site, attempt to interfere with its operation, or access it
            in ways not intended by the platform.
          </li>
          <li>
            Automated scraping or bulk downloading of content is not permitted without prior written
            consent.
          </li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-slate-900 dark:text-on-surface mb-2">
          3. Intellectual Property
        </h2>
        <p className="text-sm text-slate-700 dark:text-on-surface-variant leading-relaxed">
          Unless otherwise noted, the text, graphics, and design of the TradeRadar site are
          protected by applicable intellectual property laws. You may link to public pages or quote
          reasonable excerpts with attribution, but you may not reproduce or distribute substantial
          parts of the site without permission.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-slate-900 dark:text-on-surface mb-2">
          4. No Investment or Trading Advice
        </h2>
        <p className="text-sm text-slate-700 dark:text-on-surface-variant leading-relaxed mb-2">
          The content on TradeRadar is provided for informational and educational purposes only. It
          does not constitute investment, trading, legal, tax, or other professional advice, and
          should not be treated as a recommendation to buy, sell, or hold any financial instrument
          or to take any specific policy or business decision.
        </p>
        <p className="text-sm text-slate-700 dark:text-on-surface-variant leading-relaxed">
          You are solely responsible for any decisions you make based on information obtained from
          this site. If you require advice tailored to your situation, you should consult an
          appropriately qualified professional.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-slate-900 dark:text-on-surface mb-2">
          5. Limitation of Liability
        </h2>
        <p className="text-sm text-slate-700 dark:text-on-surface-variant leading-relaxed">
          While reasonable efforts are made to keep information on the site accurate and
          up-to-date, TradeRadar does not guarantee completeness, accuracy, or timeliness. To the
          maximum extent permitted by law, the platform and its operators will not be liable for any
          direct or indirect loss or damage arising from your use of, or reliance on, the site or
          its content.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-slate-900 dark:text-on-surface mb-2">
          6. Third‑Party Links and Services
        </h2>
        <p className="text-sm text-slate-700 dark:text-on-surface-variant leading-relaxed">
          The website may contain links to external sites or embed content from third‑party
          services. These are provided for convenience and informational purposes only. TradeRadar
          does not control and is not responsible for the content, policies, or practices of any
          third‑party site or service.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-slate-900 dark:text-on-surface mb-2">
          7. Changes to These Terms
        </h2>
        <p className="text-sm text-slate-700 dark:text-on-surface-variant leading-relaxed">
          These Terms and Conditions may be updated from time to time. Any changes will be posted on
          this page with an updated effective date. By continuing to use the site after changes take
          effect, you agree to be bound by the revised terms.
        </p>
      </section>
    </article>
  );
};

export default TermsAndConditions;

